<template>
  <StoreLocatorConfigSection
    :title="$t('message.storeLocator.facilities.searchArea')"
  >
    <v-select
      v-model="countries"
      :items="choices"
      multiple
      :label="$t('message.common.select')"
      item-text="name"
      item-value="code"
      @change="handleChange"
    ></v-select>
  </StoreLocatorConfigSection>
</template>

<script>
import StoreLocatorConfigSection from "@/components/StoreLocator/StoreLocatorConfigSection";

export default {
  name: "StoreLocatorConfigSearchRegions",
  components: {
    StoreLocatorConfigSection
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    choices: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      countries: []
    };
  },
  async created() {
    this.countries = this.value;
  },
  methods: {
    handleChange() {
      this.$emit("change", this.countries);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-text-field {
  padding: 0px;
}
</style>
